import { render, staticRenderFns } from "./AnswerExplaination.vue?vue&type=template&id=18e5560c&scoped=true&"
import script from "./AnswerExplaination.vue?vue&type=script&lang=js&"
export * from "./AnswerExplaination.vue?vue&type=script&lang=js&"
import style0 from "./AnswerExplaination.vue?vue&type=style&index=0&id=18e5560c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e5560c",
  null
  
)

export default component.exports